import React, { useState } from 'react';
import UserTable from '../component/table/UserTable';
import AddUserModal from '../component/formModal/AddUserModal';

const UserDashboard = ({user}) => {
  const [showAddModal, setShowAddModal] = useState(false);
  
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3>Users</h3>
        <button
          className="btn btn-primary"
          onClick={() => setShowAddModal(true)}
          disabled={user?.role!=='ADMIN'}
        >
          <i className="fa fa-plus me-2" />
          Add New User
        </button>
      </div>
      <UserTable loginUser={user}/>
      {showAddModal && <AddUserModal onClose={() => setShowAddModal(false)} />}
    </div>
  );
};

export default UserDashboard;
